import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

import { day } from 'libs/day';
import { IHallPassErrorType, MembershipListFlags } from 'libs/domain';
import { MembershipListType } from 'libs/domain';
import { IMembershipList } from 'libs/domain';
import { HpmReportsFilter } from 'libs/domain';
import { ReportTypes } from 'libs/domain';
import { MEMBERSHIP_LISTS_DATA } from 'libs/shared';
import { Observable } from 'rxjs';

import { MembershipListTableData } from '@app/src/app/shared/components/membership-list-table';

import { HpmReportsService, HpmRoutes } from '@modules/hallpass-manager';

import { HpmRestrictionsMessages } from './constants';
import { HpmRestrictionsBlackoutService } from './services';
import { HpmRestrictionsService } from './services/hpm-restrictions.service';

@Component({
  selector: 'mg-hpm-restrictions',
  templateUrl: './hpm-restrictions.component.html',
  styleUrls: ['./hpm-restrictions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HpmRestrictionsComponent implements AfterViewInit {
  /** Messages */
  public readonly MESSAGES = HpmRestrictionsMessages;

  public readonly isLoading$: Observable<boolean>;

  public readonly noGroupsListMessage = MEMBERSHIP_LISTS_DATA[MembershipListType.NO_PARTY].description;

  public readonly NO_PARTY_FLAG = MembershipListFlags.HALL_PASS_ENABLED;

  get noPartyLists(): MembershipListType[] {
    return [MembershipListType.NO_PARTY];
  }

  get noPassLists(): MembershipListType[] {
    return [
      MembershipListType.NO_GRANT,
      MembershipListType.NO_PASS,
      MembershipListType.ONE_PASS,
      MembershipListType.TWO_PASS,
    ];
  }

  /** Component Constructor */
  constructor(
    public restrictionsService: HpmRestrictionsService,
    public _blackoutService: HpmRestrictionsBlackoutService,
    private _router: Router,
    private _hpmReportsService: HpmReportsService,
  ) {
    this.isLoading$ = this.restrictionsService.isLoading$;
  }

  ngAfterViewInit(): void {
    this.restrictionsService.fetchAllLists();
  }

  public async openDeniedPassesReport(list: IMembershipList) {
    this._hpmReportsService.setFilter(HpmReportsFilter.START_DATE, day().subtract(30, 'day').startOf('day'));

    this._hpmReportsService.setFilter(HpmReportsFilter.END_DATE, day().endOf('day'));
    this._hpmReportsService.setFilter(HpmReportsFilter.DENIED_BY, [IHallPassErrorType.NO_PARTY]);
    this._hpmReportsService.setFilter(HpmReportsFilter.DENIED_BY_NO_PARTY, [list.id]);
    this._hpmReportsService.applyFilter();
    await this._router.navigate([HpmRoutes.ROOT, HpmRoutes.REPORTS, ReportTypes.HALL_PASS_HISTORY]);
  }

  public async upsertNoPartyGroup(list?: MembershipListTableData) {
    this.restrictionsService.openRestrictionsEditModal({
      type: MembershipListType.NO_PARTY,
      isNewList: !list?.id,
      list,
    });
  }
}
